var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Fluids component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconFluids extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6004 1.4057L12 1.85522L11.3997 1.4057C11.5413 1.21657 11.7637 1.10522 12 1.10522C12.2363 1.10522 12.4588 1.21657 12.6004 1.4057ZM12 3.12949C11.8584 3.3273 11.6959 3.55635 11.5169 3.81187C10.8637 4.74448 9.99407 6.02636 9.12565 7.42645C8.25564 8.82909 7.39528 10.337 6.75489 11.7238C6.10124 13.1393 5.72656 14.3259 5.72656 15.1218C5.72656 16.7856 6.38751 18.3813 7.56402 19.5578C8.74052 20.7343 10.3362 21.3952 12 21.3952C13.6638 21.3952 15.2595 20.7343 16.436 19.5578C17.6125 18.3813 18.2735 16.7856 18.2735 15.1218C18.2735 14.3259 17.8988 13.1393 17.2452 11.7238C16.6048 10.337 15.7444 8.82909 14.8744 7.42645C14.006 6.02636 13.1363 4.74448 12.4831 3.81187C12.3042 3.55635 12.1416 3.3273 12 3.12949ZM12 1.85522C11.3997 1.4057 11.3998 1.40557 11.3997 1.4057L11.3939 1.41346L11.3781 1.43465L11.3178 1.51595C11.2654 1.58699 11.1888 1.69114 11.0917 1.82476C10.8974 2.09196 10.6204 2.4772 10.2883 2.95135C9.62459 3.89897 8.73838 5.20505 7.85094 6.6358C6.96508 8.064 6.06958 9.62989 5.39307 11.0949C4.72982 12.5312 4.22656 13.9745 4.22656 15.1218C4.22656 17.1834 5.04555 19.1606 6.50336 20.6184C7.96116 22.0762 9.93837 22.8952 12 22.8952C14.0617 22.8952 16.0389 22.0762 17.4967 20.6184C18.9545 19.1606 19.7735 17.1834 19.7735 15.1218C19.7735 13.9745 19.2702 12.5312 18.607 11.0949C17.9305 9.62989 17.035 8.064 16.1491 6.6358C15.2617 5.20505 14.3755 3.89897 13.7118 2.95135C13.3797 2.4772 13.1027 2.09196 12.9084 1.82476C12.8112 1.69114 12.7347 1.58699 12.6822 1.51595L12.622 1.43465L12.6062 1.41346L12.6004 1.4057C12.6003 1.40557 12.6004 1.4057 12 1.85522Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconFluids.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconFluids.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconFluids.prototype, "size", void 0);
if (customElements.get('cat-icon-fluids') === undefined) {
    customElements.define('cat-icon-fluids', BlocksIconFluids);
}
